import {CardHeaderConfig} from '@shared/module/card/model/card-header-config.interface';

export interface CardConfig {
  headerConfig?: CardHeaderConfig;
  css?: string;
}
